import service from '@/services'
import SparkMD5 from 'spark-md5';

// export function commonUploadFile(params, type, spaceId) {
//   let fileReader = new FileReader()
//   const dataFile = params.file
//   let spark = new SparkMD5()
//   let md5 = ''
//   fileReader.readAsBinaryString(dataFile)
//   return new Promise((resolve, reject) => {
//     fileReader.onload = function (e) {
//       spark.appendBinary(e.target.result)
//       md5 = spark.end()
//       const params = {
//         file: dataFile,
//         resourceType: type,
//         md5: md5
//         // spaceId: spaceId
//       }
//       service.videoProduceUpload(params).then(res => {
//         resolve(res)
//       }).catch(e => {
//         throw new Error(e)
//       })
//     }
//   })
// }
export function commonUploadFile(params, type, spaceId, callback) {
  let fileReader = new FileReader()
  const dataFile = params.file
  let spark = new SparkMD5()
  let md5 = ''
  fileReader.readAsBinaryString(dataFile)
  fileReader.onload = function (e) {
    spark.appendBinary(e.target.result)
    md5 = spark.end()
    const params = {
      file: dataFile,
      resourceType: type,
      md5: md5,
      spaceId: spaceId
    }
    callback(service.videoProduceUpload(params))
  }
}
